import { overviewStats } from '@/mocks/indexNav';

const heroChips = [
  { label: '黑料索引', href: '#index' },
  { label: '黑料目录', href: '#guide' },
  { label: '黑料导航', href: '#feed' },
  { label: '黑料列表', href: '#ranking' },
];

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[600px] w-full items-end md:min-h-[700px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20editorial%20collage%20of%20stacked%20newspaper%20columns%20and%20blurred%20stage%20spotlights%2C%20deep%20crimson%20and%20warm%20amber%20tones%20on%20near%20black%20background%2C%20dramatic%20contrast%2C%20grainy%20film%20texture%2C%20moody%20magazine%20cover%20atmosphere%2C%20dark%20negative%20space%20at%20center%20for%20headline%2C%20high%20detail%2C%20artistic&width=1600&height=900&seq=hl-hero-2026-01&orientation=landscape"
          alt="黑料一区 索引门户主视觉：堆叠的资讯版面与舞台灯影艺术背景"
          title="黑料一区 索引门户主视觉"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/75 via-background-950/50 to-background-950/85" />
        <div className="absolute inset-0 grid-texture opacity-[0.35]" />
      </div>

      <div className="relative z-10 w-full px-4 pb-12 pt-32 md:px-8 md:pb-16 md:pt-40">
        <div className="mx-auto w-full max-w-[1280px]">
          <div className="flex items-center gap-3 text-accent-300">
            <span className="h-px w-10 bg-accent-400" />
            <span className="font-label text-xs tracking-[0.34em] uppercase">Aggregated Index</span>
          </div>

          <h2 className="mt-5 max-w-3xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-[52px] md:leading-[1.15]">
            按图索骥，一区黑料索引总览
          </h2>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/85 md:text-base">
            黑料索引、目录导航与列表总览集中呈现，把分散的条目按题材、热度、地区与时间归档成清晰的指引，
            按图索骥快速定位目标内容，查找省时省力。
          </p>

          <div className="mt-7 flex flex-wrap items-center gap-3">
            {heroChips.map((chip) => (
              <a
                key={chip.label}
                href={chip.href}
                className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-2 text-sm text-background-50 whitespace-nowrap cursor-pointer backdrop-blur-sm transition-colors hover:border-accent-300 hover:bg-accent-500/20"
              >
                <span className="h-1.5 w-1.5 rounded-full bg-accent-400" />
                {chip.label}
              </a>
            ))}
          </div>

          <div className="mt-10 grid grid-cols-2 gap-x-6 gap-y-6 border-t border-background-50/20 pt-6 md:grid-cols-4 md:gap-x-8">
            {overviewStats.map((stat) => (
              <div key={stat.label} className="flex flex-col gap-1">
                <span className="font-label text-2xl font-semibold text-background-50 md:text-3xl">{stat.value}</span>
                <span className="text-xs tracking-wide text-accent-200">{stat.label}</span>
                <span className="text-[11px] text-background-100/60">{stat.note}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}